module.exports = __webpack_public_path__ + "img/00004.e24fb8b1.webp";